import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import { TextButton, ContainedButton } from 'components/core/Button';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mPlanning from 'models/planning';
// Custom
import { planningDataShape, errorShape } from 'constants/PropTypesShapes';
import withFormManagement from 'hocs/WithFormManagement';
import withStateReinit from 'hocs/WithStateReinit';
import RowDetailsTemplate from 'components/templates/RowDetailsTemplate';
import Callout from 'components/misc/Callout';
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';
import PlanningWeekEdit from 'components/plannings/PlanningWeekEdit';

class PlanningRowDetails extends React.Component {
  constructor(props) {
    super(props);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  // Handlers
  handleCancel(e) {
    e.preventDefault();
    const { onResetForm } = this.props;
    // Reinit form with initial planning data
    onResetForm();
  }

  handleSave(e) {
    e.preventDefault();
    const { fields: { events }, planning, onUpdate } = this.props;
    onUpdate(
      planning,
      mPlanning.serialize({
        slots: mPlanning.eventsToSlots(events),
      }),
    );
  }

  render() {
    const {
      fields: { events }, errors,
      planning, editable, onFieldsChange,
    } = this.props;

    // Check if modifications have been done
    const modified = !mPlanning.slotsAreEqual(mPlanning.eventsToSlots(events), planning.slots);

    // Permissions
    const { pInstallation: { planningWrite } } = permissions;

    return (
      <RowDetailsTemplate>
        <div className="p-3">
          <OnlyWith
            permissions={{
              needed: planningWrite,
              permissionsOrContext: 'installationPermissions',
            }}
          >
            <div className="pb-3">
              {modified ? (
                <Callout
                  severity="warning"
                  action={(
                    <div className="d-flex justify-content-end right-spaced-buttons">
                      <TextButton
                        label={<LocalizedMessage id="button.cancel" />}
                        size="small"
                        onClick={this.handleCancel}
                      />
                      <ContainedButton
                        label={<LocalizedMessage id="button.save" />}
                        size="small"
                        onClick={this.handleSave}
                      />
                    </div>
                  )}
                >
                  <LocalizedMessage id="info.modificationsNotSaved" />
                </Callout>
              ) : (
                <Callout>
                  <LocalizedMessage id="info.quickEdit" />
                </Callout>
              )}
              {errors && (
                <div className="pt-3">
                  <ErrorsDisplayer errors={errors} />
                </div>
              )}
            </div>
          </OnlyWith>
          <PlanningWeekEdit
            events={events}
            editable={editable}
            onChange={(value) => onFieldsChange({ events: value })}
          />
        </div>
      </RowDetailsTemplate>
    );
  }
}

PlanningRowDetails.propTypes = {
  planning: planningDataShape.isRequired,
  editable: PropTypes.bool.isRequired,
  operationError: errorShape, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onResetForm: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

PlanningRowDetails.defaultProps = {
  operationError: null,
  errors: null,
};

const mapStateToProps = (state) => ({
  operationError: state.installationPlanning.update.error,
});

const mapFieldsToProps = {
  events: {
    resourceKey: 'slots',
    defaultValue: [],
    setTransform: (slots) => (mPlanning.slotsToEvents(slots)),
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: _get(ownProps, 'planning'),
  operationError: ownProps.operationError,
});

module.exports = compose(
  connect(
    mapStateToProps,
  ),
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources),
  withStateReinit(['updateInstallationPlanning']),
)(PlanningRowDetails);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/plannings/PlanningRowDetails.js